export function marketingPaths(url: string, isProducton: boolean): string {
  if (isProducton) {
    return `https://spoutstudio.io/${url}`;
  }
  return `https://dev.spoutstudio.io/${url}`;
}
